import axios from '../util/axiosConfig';

export const fetchRefDoctorsAPI = async (payload) => {
    let data = {
        ...payload,
       page: Math.max(0, (payload.page || 1) - 1),
    }
    return await axios.post(`/api/v1/referenced-doctor/referred-doctors`, data).then(function (response) {
        if (response.data) {
            return { success: true, data: response.data }
        } else {
            return { success: false }
        }
    }).catch(function (error) {
        return { success: false, error }
    })
}

export const addUpdateRefDoctorAPI = async (doctor) => {
    return await axios.post(`/api/v1/referenced-doctor/add-update-referred-doctor`, doctor)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data }
            }
            else {
                return { success: false }
            }
        })
        .catch(function (error) {
            return { success: false, error }
        })
}


export const deleteRefDoctorAPI = async (referredDoctorId) => {
    return await axios.get(`/api/v1/referenced-doctor/delete-referred-doctor`, {
        params: {
            referredDoctorId
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data }
            }
            else {
                return { success: false }
            }
        })
        .catch(function (error) {
            return { success: false, error }
        })
}

export const deleteProviderLocationAPI = async (providerLocationId) => {
    return await axios.get(`/api/v1/provider-location/delete-provider-location`, {
        params: {
            providerLocationId
        }
    })
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data }
            }
            else {
                return { success: false }
            }
        })
        .catch(function (error) {
            return { success: false, error }
        })
}

export const fetchAllRefDoctorsAPI = async () => {
    return await axios.get(`/api/v1/referenced-doctor/fetch-referenced-doctors`).then(function (response) {
        if (response.data) {
            return { success: true, data: response.data }
        } else {
            return { success: false }
        }
    }).catch(function (error) {
        return { success: false, error }
    })
}